import { combineReducers } from 'redux'
import { loadingReducer } from 'redux-foundry'
import { API_LISTAR_CONVERSOES_MASSA } from 'store/modules/api/conversoesMassa.actions'

const lista = (state = [], { type, payload }) => (
  (type === API_LISTAR_CONVERSOES_MASSA.success) ? payload : state
)

const isCarregandoLista = loadingReducer(false, API_LISTAR_CONVERSOES_MASSA)

export default combineReducers({
  lista,
  isCarregandoLista,
})
